module.exports = __webpack_public_path__ + "img/till.5d4558f9.png";